import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { faqData } from "../lib/data";
import { useLang } from "../context/LanguageContext";

export function FaqAccordion({ items }) {
  const { lang } = useLang();
  const list = items || faqData(lang);
  return (
    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
      {list.map((f, i) => (
        <AccordionItem key={i} value={`item-${i}`} className="border-b" style={{ borderColor: "var(--lo-border)" }}>
          <AccordionTrigger className="font-display text-xl md:text-2xl text-left py-6 hover:no-underline" style={{ fontWeight: 400, color: "var(--lo-text)" }} data-testid={`faq-q-${i}`}>
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-sm leading-relaxed pb-6" style={{ color: "var(--lo-muted)" }}>
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
